import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class BackdatedSubmissionsManager {
  //saveActivities
  async saveStats(stats) {
    try {
      let oldStats = await PBStorage.get(
        LOCAL_STORAGE_KEYS.ACTIVITY_BACKDATED_SUBMISSIONS,
      );
      stats.custom = oldStats ? oldStats.custom : null;
      await PBStorage.set(
        LOCAL_STORAGE_KEYS.ACTIVITY_BACKDATED_SUBMISSIONS,
        stats,
      );
      return true;
    } catch (e) {
      console.log('saveStatsFailed', e);
      return false;
    }
  }

  async saveCustomStats(customStats) {
    try {
      let stats = await PBStorage.get(
        LOCAL_STORAGE_KEYS.ACTIVITY_BACKDATED_SUBMISSIONS,
      );

      if (stats) {
        stats.custom = customStats.custom_date;
        await PBStorage.set(
          LOCAL_STORAGE_KEYS.ACTIVITY_BACKDATED_SUBMISSIONS,
          stats,
        );
      }

      return true;
    } catch (e) {
      console.log('saveStatsFailed', e);
      return false;
    }
  }

  async getStats() {
    let stats = await PBStorage.get(
      LOCAL_STORAGE_KEYS.ACTIVITY_BACKDATED_SUBMISSIONS,
    );
    return stats;
  }
}

export default new BackdatedSubmissionsManager();
